module.exports = __webpack_public_path__ + "img/android.169acee1.svg";